module.exports = __webpack_public_path__ + "static/media/future-tense-spanish.d9bdb634.jpg";